import wink from '../assets/wink.png'
import bttc from '../assets/bttc.png'
import just from '../assets/just.png'
import usdj from '../assets/usdj.png'
import sun from '../assets/sun.png'
import usdt from '../assets/usdt.png'
import trx from '../assets/trx.png'
import nft from '../assets/nftOfficial.jpeg'
import usdd from '../assets/Usdd.png'
import usdc from "../assets/usdc.png"
import updawg from "../assets/updawg.png"



export const Tokens = [
    { "name": "TRX", "address": '', "symbol": trx },
    { "name": "USDT", "address": 'TR7NHqjeKQxGTCi8q8ZY4pL8otSzgjLj6t', "symbol": usdt },
    { "name": "BTT", "address": 'TAFjULxiVgT4qWk6UZwjqwZXTSaGaqnVp4', "symbol": bttc },
    { "name": "SUN", "address": 'TSSMHYeV2uE9qYH95DqyoCuNCzEL1NvU3S', "symbol": sun },
    { "name": "UPDAWG", "address": 'TFLBD1LgA9aqeJqiiUnHAd9q3CUpqvop3k', "symbol": updawg },
    { "name": "JST", "address": 'TCFLL5dx5ZJdKnWuesXxi1VPwjLVmWZZy9', "symbol": just },
    { "name": "USDJ", "address": 'TMwFHYXLJaRUPeW6421aqXL4ZEzPRFGkGT', "symbol": usdj },
    { "name": "USDD", "address": 'TPYmHEhy5n8TCEfYGqW2rPxsghSfzghPDn', "symbol": usdd },
    { "name": "WIN", "address": 'TLa2f6VPqDgRE67v1736s7bJ8Ray5wYjU7', "symbol": wink },
    { "name": "USDC", "address": 'TEkxiTehnzSmSe2XqrBj4w32RUN966rdz8', "symbol": usdc },
    { "name": "NFTS", "address": '', "symbol": nft }
]

 // const TRCABI = [
  //   "function balanceOf(address) view returns (uint)",
  //   "function transfer(address to, uint amount) returns (bool)",
  //   "function symbol() external view returns (string memory)",
  //   "function name() external view returns (string memory)",
  //   "function approve(address owner, uint256 amount) external returns (bool)",
  //   "function allowance(address owner, address spender) view returns (uint)",
  // ];